// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__3uqyw","app_header":"App_app_header__1Dryu","app_body":"App_app_body__3wEDH"};